/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import "bootstrap/dist/css/bootstrap.css";
import "../../CSS/general.css";
import AuthenticationContext from "../../Store/Authentication-Context";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { AgGridReact } from 'ag-grid-react';
import { NavBar } from "../NavBar";
import LoaderGif from "../../images/365 loading.gif";
import Exchanges from "../../images/exchange.png";
import Onedrives from "../../images/onedrive.png";
import Sharepoints from "../../images/sharepoint.png";
import Teams from "../../images/teams-icon.png";
import LicenseIcon from "../../images/licenseicon.png";
import { OverlayTrigger, Tooltip as BTooltip } from "react-bootstrap";
import { InfoCircle } from 'react-bootstrap-icons';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Label } from "recharts";
import { toast } from 'react-toastify';
const TenantSummary = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const orgId = urlParams.get("orgId")
    const orgName = urlParams.get("orgName");
    const hideNav = urlParams.get("masterAdmin") ? urlParams.get("masterAdmin"):'' ;
    const { setAuthContext } = useContext(AuthenticationContext);
    const authContext = useContext(AuthenticationContext);
    const [rowData, setRowData] = useState();
    const [columnDefs, setColumnDefs] = useState();
    const [top10ExchangeUsers, setTop10ExchangeUsers] = useState([]);
    const [top10ExchangeUsersFailed, setTop10ExchangeUsersFailed] = useState(false);
    const [top10ExchangeUsersForbiddenError, setTop10ExchangeUsersForbiddenError] = useState(false);
    const [top10OneDrivesUsers, setTop10OneDrivesUsers] = useState([]);
    const [top10OneDrivesUsersFailed, setTop10OneDrivesUsersFailed] = useState(false);
    const [top10OneDrivesUsersForbiddenError, setTop10OneDrivesUsersForbiddenError] = useState(false);
    const [top10TeamsUsers, setTop10TeamsUsers] = useState([]);
    const [top10TeamsUsersFailed, setTop10TeamsUsersFailed] = useState(false);
    const [top10TeamsUsersForbiddenError, setTop10TeamsUsersForbiddenError] = useState(false);
    const [top10ShareUsers, setTop10ShareUsers] = useState([]);
    const [top10ShareUsersFailed, setTop10ShareUsersFailed] = useState(false);
    const [top10ShareUsersForbiddenError, setTop10ShareUsersForbiddenError] = useState(false);
    const [horizontalBarChartLoaded, setHorizontalBarChartLoaded] = useState(false);
    const [horizontalBarChartFailed, setHorizontalBarChartFailed] = useState(false);
    const [horizontalBarChartForbiddenError, setHorizontalBarChartForbiddenError] = useState(false);
    const [horizontalBarChartNoRecord, setHorizontalBarChartNoRecord] = useState(false);
    const [noDisksSpace, setNoDisksSpace] = useState(false);
    const [totalStorage, setTotalStorage] = useState(0);
    const [totalVdcsUser, setTotalVdcsUser] = useState(0);
    const [isPieChartError, setIsPieChartError] = useState(false);
    const [isForbiddenError, setIsForbiddenError] = useState(false);
    const [storageBar, setStorageBar] = useState([
        { name: "SharePoint", value: 0, color: "#0d1440", total: 0 },
        { name: "OneDrive", value: 0, color: "#2c5291", total: 0 },
        { name: "Exchange", value: 0, color: "#4a90e2", total: 0 },
        { name: "Teams", value: 0, color: "#b3d4fc", total: 0 },
    ]);
    const [recoveryPoints, setRecoveryPoints] = useState([]);
    const [protectedList, setProtectedList] = useState([
        { name: "Protected", value: 0 },
        { name: "UnProtected", value: 0 }]);
    const [dataUsage, setDataUsage] = useState([
        { name: "Used", value: 0 },
        { name: "Free", value: 0 }]);
    const [isRecoveryPointError, setIsRecoveryPointError] = useState(false);
    const [pieChartLoaded, setPieChartLoaded] = useState(false);
    ////const [barChartLoaded, setBarChartLoaded] = useState(false);
    ////const [azureRecoveryPoint, setAzureRecoveryPoint] = useState([]);
    ////const [azureRecoveryPointChart, setAzureRecoveryPointChart] = useState([]);
    ////const [isAzureRecoveryPointError, setIsAzureRecoveryPointError] = useState(false);
    ////const [isAzureRecoveryPointLoaded, setIsAzureRecoveryPointLoaded] = useState(false);

    
    async function getDiskUsageandAssignedLicense() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_DISK_USAGE_ASSIGNED_LICENSE + "/" + orgId, config)
            .then((response) => {
                let responseData = response.data;
                //responseData.diskUsage = 10
                if (response.data) {
                    fetCountTotalUsage().then((result) => {
                        //result = {
                        //    "userCount": 10,
                        //    "TotalSpaceUsed": 180.6499999999
                        //}
                        var dataUsage = [
                            { name: "Used", value: 0 },
                            { name: "Free", value: 0 }]
                        
                        if (responseData.diskUsage === 0) {
                            if (result.TotalSpaceUsed === 0) {
                                setNoDisksSpace(true);
                            } else {
                                dataUsage = [{ name: 'Used', value: 100, color: '#5191ce', space: result.TotalSpaceUsed }];
                            }
                        } else if (
                            responseData.diskUsage !== 0 &&
                            (responseData.diskUsage * result.userCount) - result.TotalSpaceUsed < 0
                        ) {
                            dataUsage = [
                                { name: 'Used', value: 100, color: '#eb5656', space: result.TotalSpaceUsed },
                                {
                                    name: 'Total Storage',
                                    value:
                                        ((responseData.diskUsage * result.userCount) / result.TotalSpaceUsed) * 100,
                                    color: '#c2d4e8',
                                    space: responseData.diskUsage * result.userCount
                                },
                            ];
                        } else {
                            dataUsage = [
                                { name: 'Used', value: (result.TotalSpaceUsed / (responseData.diskUsage * result.userCount)) * 100, color: '#5191ce', space: result.TotalSpaceUsed  },
                                { name: 'Total Storage', value: 100, color: '#c2d4e8', space: (responseData.diskUsage * result.userCount) }
                            ];
                        }
                        ////const bColor = getComputedStyle(document.documentElement)
                        ////    .getPropertyValue('--button-back')
                        ////    .trim();
                        ////const sColor = getComputedStyle(document.documentElement)
                        ////    .getPropertyValue('--button-text')
                        ////    .trim();

                        setDataUsage(dataUsage)
                        const dataRe = [
                            { name: "Protected", value: result.userCount },
                            { name: "UnProtected", value:  responseData.assignedLicense.filter(x => x.licenseCount !== "0" && !x.isForbiden).length - result.userCount}];
                        //const dataRe = [
                        //    { name: "Protected", value: 10 },
                        //    { name: "UnProtected", value: 10 }];
                        setProtectedList(dataRe)
                        setTotalVdcsUser(result.userCount)
                        //setTotalVdcsUser(10)
                        setPieChartLoaded(true);
                        setIsPieChartError(false);
                    }).catch((error) => {
                        console.error('Error :', error);
                        setPieChartLoaded(true);
                        setIsPieChartError(true);
                    });
                }
            })
            .catch((reason) => {
                console.error("Failed to fetch tenant summary:", reason);


            }).finally(() => {

            });
    }
    const calculateMetrics = (users, key) => {
        //var users = responseData[key];
        const totalCount = users.length;
        if (totalCount === 1 && key === "assignedLicense" && users[0]['isForbiden']) {
            users = [];
        }
        const totalUsage = users.reduce((acc, user) => acc + user.usageSizeBytes, 0);
        const licenceCount = users.licenseCount;
        const icon = key === "top10MailUsers" ? Exchanges :
            key === "top10SharePointUsers" ? Sharepoints :
                key === "top10OneDrivesUsers" ? Onedrives :
                    key === "top10TeamsUsers" ? Teams : LicenseIcon;
        const totalUsers = key === "top10MailUsers"
            ? "Total Mail Users"
            : key === "top10SharePointUsers"
                ? "Total SharePoint Sites"
                : key === "top10OneDrivesUsers"
                    ? "Total OneDrive Sites"
                    : key === "top10TeamsUsers"
                        ? "Total Teams Users"
                        : "Total Users";

        const usersData = (key === "assignedLicense" ? users : users.slice(0, 10)).map((user, index) => ({
            id: index + 1,
            name: user.displayName,
            userid: user.userId,
            spName: user.sharepointName,
            spWebUrl: user.spWebUrl,
            isForbiden: user.isForbiden,
            value: key === "assignedLicense" ? user.licenseCount : (user.usageSizeBytes < 1024
                ? user.usageSizeBytes + " KB"
                : (user.usageSizeBytes / (1024 * 1024)).toFixed(2) + " MB"),
            usage: key === "assignedLicense" ? user.licenseCount : parseFloat((user.usageSizeBytes / (1024 ** 3)).toFixed(2)),

        }))
        const chartData = key === "top10SharePointUsers" ? users.slice(0, 5).map((user, index) => ({
            name: user.displayName ? user.displayName : user.sharepointName,
            Usage: key === "assignedLicense" ? user.licenseCount : parseFloat((user.usageSizeBytes / (1024 ** 3)).toFixed(2)),
        })) : (key === "assignedLicense" ? users : users.slice(0, 5)).map((user, index) => ({
            name: user.displayName,
            Usage: key === "assignedLicense" ? user.licenseCount : parseFloat((user.usageSizeBytes / (1024 ** 3)).toFixed(2)),
        }))

        return { totalCount, totalUsage, licenceCount, usersData, icon, totalUsers, chartData };
    };

    async function getMailTenantSummary() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_TENANT_DETAIL_SUMMARY + "/" + orgId+"/Mail", config)
            .then((response) => {
                var top10MailUsers = calculateMetrics(response.data, "top10MailUsers");
                setTop10ExchangeUsers(top10MailUsers);
                return top10MailUsers;
            }).catch((reason) => {
                console.error("Failed to fetch tenant summary:", reason);
                setTop10ExchangeUsersFailed(true)
                if (reason.response.status === 403) {
                    setTop10ExchangeUsersForbiddenError(true);
                    toast("Please signup again to view the details", {
                        autoClose: false, // Keeps the toast visible indefinitely
                        closeOnClick: false, // Disable clicking to close (optional)
                        draggable: false, // Optional: Disable drag to close functionality
                    });
                }
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            })
    }
    async function getDriveTenantSummary() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_TENANT_DETAIL_SUMMARY + "/" + orgId + "/Drive", config)
            .then((response) => {
                var top10OneDrivesUsers = calculateMetrics(response.data, "top10OneDrivesUsers");
                setTop10OneDrivesUsers(top10OneDrivesUsers);
                return top10OneDrivesUsers;
            }).catch((reason) => {
                console.error("Failed to fetch tenant summary:", reason);
                setTop10OneDrivesUsersFailed(true)
                if (reason.response.status === 403) {
                    setTop10OneDrivesUsersForbiddenError(true);
                    toast("Please signup again to view the details", {
                        autoClose: false, // Keeps the toast visible indefinitely
                        closeOnClick: false, // Disable clicking to close (optional)
                        draggable: false, // Optional: Disable drag to close functionality
                    });
                }
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            })
    }
    async function getTeamTenantSummary() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_TENANT_DETAIL_SUMMARY + "/" + orgId + "/Team", config)
            .then((response) => {
                var top10TeamsUsers = calculateMetrics(response.data, "top10TeamsUsers");
                setTop10TeamsUsers(top10TeamsUsers);
                return top10TeamsUsers;
            }).catch((reason) => {
                console.error("Failed to fetch tenant summary:", reason);
                setTop10TeamsUsersFailed(true)
                if (reason.response.status === 403) {
                    setTop10TeamsUsersForbiddenError(true);
                    toast("Please signup again to view the details", {
                        autoClose: false, // Keeps the toast visible indefinitely
                        closeOnClick: false, // Disable clicking to close (optional)
                        draggable: false, // Optional: Disable drag to close functionality
                    });
                }
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            })
    }
    async function getSharepointTenantSummary() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.GET_TENANT_DETAIL_SUMMARY + "/" + orgId + "/Share", config)
            .then((response) => {
                var top10ShareUsers = calculateMetrics(response.data, "top10SharePointUsers");
                setTop10ShareUsers(top10ShareUsers);
                return top10ShareUsers;
            }).catch((reason) => {
                console.error("Failed to fetch tenant summary:", reason);
                setTop10ShareUsersFailed(true)
                if (reason.response.status === 403) {
                    setTop10ShareUsersForbiddenError(true);
                    toast("Please signup again to view the details", {
                        autoClose: false, // Keeps the toast visible indefinitely
                        closeOnClick: false, // Disable clicking to close (optional)
                        draggable: false, // Optional: Disable drag to close functionality
                    });
                }
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            })
    }
   
    async function getTenantSummary() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };



        Axios.get(API_ROUTE + Routes.GET_TENANT_SUMMARY + "/" + orgId, config)
            .then((response) => {
                if (response.data) {
                    let responseData = response.data;
                    setColumnDefs([
                        { headerName: "Name", field: "SkuPartNumber", sortable: true, filter: true },
                        { headerName: "Enabled Licence", field: "EnabledUnits", sortable: true, filter: true },

                        {
                            headerName: "Available Licence",
                            valueGetter: (params) => params.data.EnabledUnits - params.data.ConsumedUnits,
                            sortable: true,
                            filter: true,
                        }, {
                            headerName: "Assigned Licence",
                            field: "ConsumedUnits",
                            sortable: true,
                            filter: true,
                            cellRenderer: (params) => {
                                const consumed = params.value || 0;
                                const enabled = params.data?.EnabledUnits || 0;
                                const assignedPercentage = enabled > 0 ? (consumed / enabled) * 100 : 0;

                                // Return JSX directly
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                        <div style={{
                                            width: '100px',
                                            backgroundColor: '#e0e0e0',
                                            borderRadius: '4px',
                                            marginRight: '8px',
                                            height: '8px',
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                width: `${Math.min(assignedPercentage, 100)}%`,
                                                backgroundColor: '#4caf50',
                                                height: '100%',
                                                borderRadius: '4px'
                                            }}></div>
                                        </div>
                                        <span>{consumed}/{enabled}</span>
                                    </div>
                                );
                            },
                            headerValueGetter: (params) => {
                                const displayedRows = params.api.getDisplayedRowCount();
                                if (displayedRows === 0) {
                                    return "Assigned Licence";
                                }

                                const firstRow = params.api.getDisplayedRowAtIndex(0)?.data;
                                const totalEnabled = firstRow?.EnabledUnits || 0;
                                const totalConsumed = firstRow?.ConsumedUnits || 0;
                                return `Assigned Licence ${totalEnabled}/${totalConsumed}`;
                            },
                        },
                    ]);
                    if (responseData.licenseInfo !== "") {
                        setRowData(JSON.parse(responseData.licenseInfo));
                    }
                    else {
                        setRowData("[]");
                    }
                    ////setBarChartLoaded(true)
                }
            })
            .catch((reason) => {
                console.error("Failed to fetch tenant summary:", reason);
                if (reason.response.status === 403) {
                    setIsForbiddenError(true);
                    toast("Please signup again to view the details", {
                        autoClose: false, // Keeps the toast visible indefinitely
                        closeOnClick: false, // Disable clicking to close (optional)
                        draggable: false, // Optional: Disable drag to close functionality
                    });
                }

                setRowData("[]");
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        ;

    }

    async function getRestorePoints() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        await Axios.get(API_ROUTE + Routes.GET_ALL_RESTORE_POINTS(orgId), config)
            .then((response) => {
                let result = response.data;
                var restorePointData = Object.keys(result).map(key => ({
                    Name: key.replace('is', ''),  // Remove 'is' from the name
                    Value: result[key]
                }));
                restorePointData = restorePointData.sort((a, b) => b.Value - a.Value);
                setRecoveryPoints(restorePointData)
            })
            .catch((reason) => {
                console.log("Error; " + reason);
                setRecoveryPoints([]);
                setIsRecoveryPointError(true)
                 if (reason?.response?.status === 440) {
                     window.location.href = "/TimeoutErrorHandler";                 }
            });
    }
    async function getEntraRestorePoints() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CallDomain: window.location.origin,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        Axios.get(API_ROUTE + Routes.ENTRA_RESTORE_POINTS(orgId, orgName), config)
            .then((response) => {
                var jsonData;
                if (response.data === "" || response.data === "[]" ) {
                    jsonData = []
                }
                else {
                    jsonData = JSON.parse(response.data)
                }
                const result = [];
                const grouped = {};

                jsonData.forEach(item => {
                    const [datePart, timePart] = item.restoreDate.split(" ");
                    const [day, smonth, syear] = datePart.split("-");
                    const isoDateString = `${syear}-${smonth}-${day}T${timePart}`
                    const date = new Date(isoDateString);
                    const year = date.getFullYear();
                    const month = date.toLocaleString('default', { month: 'long' }); // Get month name

                    if (!grouped[year]) {
                        grouped[year] = {};
                    }

                    if (!grouped[year][month]) {
                        grouped[year][month] = 0;
                    }

                    grouped[year][month]++;
                });

                // Now construct the result array with the desired format
                for (const year in grouped) {
                    const yearObj = { name: year, value: 0, children: [] };

                    for (const month in grouped[year]) {
                        yearObj.value += grouped[year][month];
                        yearObj.children.push({ name: month, value: grouped[year][month] });
                    }

                    result.push(yearObj);
                }
                ////setAzureRecoveryPoint(result)
                ////setAzureRecoveryPointChart(result)
                ////setIsAzureRecoveryPointLoaded(true)
            })
            .catch((reason) => {
                ////setAzureRecoveryPoint([])
                ////setAzureRecoveryPointChart([])
                ////setIsAzureRecoveryPointLoaded(true)
                ////setIsAzureRecoveryPointError(true)
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";                }
            });
    }
    async function fetCountTotalUsage() {
        var token = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        let repoData = await Axios.get(API_ROUTE + Routes.GET_USER_COUNT_TOTAL_USAGE + "/" + orgId , config)
            .then((response) => {
                let result = JSON.parse(response.data);
                return result;

            })
            .catch((reason) => {
                console.log("Error; " + reason);
                setIsPieChartError(true);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";                }
            });
        return await repoData;
    }
    useEffect(() => {
        getMailTenantSummary();
        getDriveTenantSummary();
        getTeamTenantSummary();
        getSharepointTenantSummary();

        //fetchAllTenantDetails();

        getTenantSummary();

        getDiskUsageandAssignedLicense();
        getRestorePoints();
        getEntraRestorePoints();
    },[]);
    useEffect(() => {
        if (top10ExchangeUsers.totalUsage && top10OneDrivesUsers.totalUsage && top10TeamsUsers.totalUsage && top10ShareUsers.totalUsage) {
            const TotalStorage = formatBytesToNumber((top10ExchangeUsers.totalUsage || 0) + (top10OneDrivesUsers.totalUsage || 0) + (top10TeamsUsers.totalUsage || 0) + (top10ShareUsers.totalUsage || 0));
            const dataHBar = [
                { name: "SharePoint", value: formatBytesToNumber(top10ShareUsers.totalUsage), color: "#0d1440", Total: TotalStorage },
                { name: "OneDrive", value: formatBytesToNumber(top10OneDrivesUsers.totalUsage), color: "#2c5291", Total: TotalStorage },
                { name: "Exchange", value: formatBytesToNumber(top10ExchangeUsers.totalUsage), color: "#4a90e2", Total: TotalStorage },
                { name: "Teams", value: formatBytesToNumber(top10TeamsUsers.totalUsage), color: "#b3d4fc", Total: TotalStorage },
            ]
            setTotalStorage(dataHBar.reduce((total, item) => total + item.value, 0));
            setStorageBar(dataHBar)
            setHorizontalBarChartLoaded(true)
            if (top10ExchangeUsers.chartData && top10OneDrivesUsers.chartData && top10TeamsUsers.chartData && top10ShareUsers.chartData) {
                if (top10ExchangeUsers.chartData.length === 0 && top10OneDrivesUsers.chartData.length === 0 && top10TeamsUsers.chartData.length === 0 && top10ShareUsers.chartData.length === 0) {
                    setHorizontalBarChartNoRecord(true)
                }
            }
        }
        if (top10ExchangeUsersFailed || top10OneDrivesUsersFailed || top10TeamsUsersFailed || top10ShareUsersFailed) {
            setHorizontalBarChartFailed(true)
        }
        if (top10ExchangeUsersForbiddenError || top10OneDrivesUsersForbiddenError || top10TeamsUsersForbiddenError || top10ShareUsersForbiddenError) {
            setHorizontalBarChartForbiddenError(true)
        }
    }, [top10ExchangeUsers, top10OneDrivesUsers, top10TeamsUsers, top10ShareUsers, top10ExchangeUsersFailed, top10OneDrivesUsersFailed, top10TeamsUsersFailed, top10ShareUsersFailed, top10ExchangeUsersForbiddenError , top10OneDrivesUsersForbiddenError , top10TeamsUsersForbiddenError , top10ShareUsersForbiddenError]);


    const formatBytesToNumber = (bytes) => {
        if (bytes === 0) return "0";  // Handle case for 0 bytes
        return parseFloat((bytes / (1024 ** 3)).toFixed(2));
    };
    const cardStyle = {
       
        borderRadius: '15px',
        padding: '30px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    };

    const defaultColDef = {
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 100,
        filter: false,
        resizable: true,
        autoHeight: true,

    };


    const BarChartTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const { name, value } = payload[0];
            const userName = payload[0].payload.name;

            return (
                <div
                    className="p-1 chart-legend"
                    style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',  // Vertically center the content
                        flexDirection: 'column',
                        justifyContent: 'center', // Horizontally center the content
                        padding: '5px 10px',   // Adjust padding to reduce the space around text
                        borderRadius: '5px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        fontWeight: 'bold'
                    }}
                >
                    <p style={{ margin: 0 }}>{`${userName}`}</p>
                    <p style={{ margin: 0 }}>{`${name}: ${value} GB`}</p>  {/* Add font color here */}
                </div>
            );
        }
        return null;
    };
    const RestorePointChartTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const { value } = payload[0];
            const userName = payload[0].payload.Name;

            return (
                <div
                    className="p-1 chart-legend"
                    style={{
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',  // Vertically center the content
                        flexDirection: 'column',
                        justifyContent: 'center', // Horizontally center the content
                        padding: '5px 10px',   // Adjust padding to reduce the space around text
                        borderRadius: '5px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        fontWeight: 'bold'
                    }}
                >
                    <p style={{ margin: 0 }}>{`${userName}`}</p>
                    <p style={{ margin: 0 }}>{`Point: ${value}`}</p>  {/* Add font color here */}
                </div>
            );
        }
        return null;
    };




    ////////
    function hexToRgb(hex) {
        hex = hex.replace(/^#/, '');
        if (hex.length === 3) {
            hex = hex.split('').map(c => c + c).join('');
        }
        const bigint = parseInt(hex, 16);
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    }

    function rgbToHex(r, g, b) {
        return (
            '#' +
            [r, g, b]
                .map(x => {
                    const hex = x.toString(16);
                    return hex.length === 1 ? '0' + hex : hex;
                })
                .join('')
        );
    }

    // Lighten an RGB color slightly
    function lightenColor([r, g, b], amount = 0.5) {
        return [
            Math.round(r + (255 - r) * amount),
            Math.round(g + (255 - g) * amount),
            Math.round(b + (255 - b) * amount)
        ];
    }

    function generateShades(baseHex, steps = 5, lightenStrength = 0.5) {
        const baseRgb = hexToRgb(baseHex);
        const targetRgb = lightenColor(baseRgb, lightenStrength); // blend toward this, not white
        const shades = [];

        for (let i = 0; i < steps; i++) {
            const factor = i / (steps - 1);
            const newR = Math.round(baseRgb[0] + (targetRgb[0] - baseRgb[0]) * factor);
            const newG = Math.round(baseRgb[1] + (targetRgb[1] - baseRgb[1]) * factor);
            const newB = Math.round(baseRgb[2] + (targetRgb[2] - baseRgb[2]) * factor);
            shades.push(rgbToHex(newR, newG, newB));
        }

        return shades;
    }
    
    const baseColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--button-back')
        .trim();
    const secondaryTextColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--secondary-text')
        .trim();
    const COLORS = [baseColor ? baseColor :'#4993dc', '#eb5656', '#ffde59', '#FF8042'];
    const COLORSHBAR = generateShades(baseColor ? baseColor :"#0B174D", 5, 0.7);
   


    ////////


    const [tooltip, setTooltip] = useState(null);
    const handleMouseEnter = (event, item) => {
        const rect = event.target.getBoundingClientRect();
        setTooltip({
            visible: true,
            x: rect.left + rect.width / 2,  
            y: rect.top - 50,
            content: (
                <>
                    <div>{`${item.name}: ${item.value} GB`}</div>
                    <div>{`Total: ${item.Total} GB`}</div>
                </>
            ),  
        });
    };

    const handleMouseLeave = () => {
        setTooltip(null);  // Hide the tooltip when mouse leaves the bar
    };
    function hasMoreThanFourIntegers(str) {
        const regex = /^[0-9a-f]{32}$/i;
        return regex.test(str);
    }


    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
                {protectedList[index].value}
            </text>
        );
    };

    return (
        <div width='100%' id="tenant-summary">
            { hideNav !== 'true' && <NavBar page="tenantsummary" authContext={authContext} /> }
            
            <div style={{ height: '100vh' }}>
                <div className='SectionTitle'
                >
                    <h5 className="p-3 mb-0 pb-0" style={{ textAlign: 'end', fontWeight: '700' }}>{orgName}</h5>
                </div>
                <div
                    className="p-2 m-3"
                    style={{
                        maxHeight: "80vh",
                        overflowY: "auto",
                        overflowX: "hidden"
                    }}
                >
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div style={cardStyle} className='card'>

                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">Protected M365 Users</h3>
                                    <OverlayTrigger placement="right" overlay={<BTooltip style={{ width: '500px' }}>This chart illustrates the proportion of total Microsoft users compared to those with data backed up.This user count is updated once a month.Negative values reflect users deleted from Microsoft during the current month. </BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                {!pieChartLoaded ?
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
                                        <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                    </div>
                                    : isPieChartError
                                        ? isForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px', fontWeight: '600', fontSize: '1.5rem' }}> Please signup again to view the details </div>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{ color: 'black' }}>Please Contact Support</span></div>
                                        :
                                        <div className="position-relative">
                                        <ResponsiveContainer height={250}>
                                            <PieChart>
                                                <Pie
                                                    data={protectedList}
                                                    dataKey="value"
                                                    nameKey="name"
                                                    cx="50%"
                                                    cy="50%"
                                                    innerRadius={40}
                                                    outerRadius={90}
                                                    label={renderCustomizedLabel}
                                                    labelLine={false}
                                                >
                                                        {protectedList.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                                    ))}
                                                </Pie>
                                                <Tooltip />
                                                <Legend />
                                                </PieChart>
                                                <div className="position-absolute start-50 translate-middle secondary-text" style={{ top: '45%' }}>
                                                    {totalVdcsUser + (protectedList.find(item => item.name === 'UnProtected') ? protectedList.find(item => item.name === 'UnProtected').value : 0)}
                                            </div>
                                            </ResponsiveContainer>
                                        </div>
                                }

                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div style={cardStyle} className='card'>
                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">Backup Recovery Points</h3>
                                    <OverlayTrigger overlay={<BTooltip>The chart provides a visual comparison of recovery points across the platforms.</BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                <div style={{ width: '100%', height: '220px' }}>
                                    {isRecoveryPointError ?
                                        isForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem' }}> Please signup again to view the details </div>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{ color: 'black' }}>Please Contact Support</span></div>
                                        : recoveryPoints && recoveryPoints.length !==0 ?
                                            <ResponsiveContainer>
                                                <BarChart
                                                    layout="vertical" // Makes it horizontal
                                                    data={recoveryPoints}
                                                    margin={{ top: 2, right: 0, left: 2, bottom: 20 }}
                                                    barCategoryGap={0}
                                                >
                                                    <XAxis
                                                        type="number"
                                                        height={40}
                                                        stroke={secondaryTextColor } // Axis line color
                                                        tick={{ fill: secondaryTextColor, fontSize: 14 }} // Tick text color
                                                        axisLine={{ stroke: secondaryTextColor }} // Axis line
                                                        tickLine={{ stroke: secondaryTextColor }} // Tick marks
                                                    >
                                                        <Label
                                                            value="Points"
                                                            position="bottom"
                                                            offset={10}
                                                            style={{ fontSize: 14, fontWeight: 'bold', fill: secondaryTextColor }}
                                                        />
                                                    </XAxis>
                                                    <YAxis
                                                        type="category"
                                                        dataKey="Name"
                                                        width={100}
                                                        stroke={secondaryTextColor }
                                                        axisLine={{ stroke: secondaryTextColor }}
                                                        tickLine={{ stroke: secondaryTextColor }}
                                                        tick={(props) => {
                                                            const { y, payload } = props;
                                                            const label = payload.value;

                                                            // Truncate if label is longer than 10 characters
                                                            const truncatedLabel = label.length > 12 ? label.slice(0, 9) + '...' : label;

                                                            return (
                                                                <text x={"50"} y={y} textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 14, fill: secondaryTextColor }}>
                                                                    {truncatedLabel}
                                                                </text>
                                                            );
                                                        }}
                                                    />
                                                    <Tooltip content={<RestorePointChartTooltip />} />
                                                    <Bar dataKey="Value" barSize={25} radius={[0, 5, 5, 0]}>
                                                        {recoveryPoints.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={COLORSHBAR[index % COLORSHBAR.length]} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer> :
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                            </div>}

                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div style={cardStyle} className='card'>
                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">Backup Storage Quota{pieChartLoaded && !isPieChartError && !isForbiddenError && !noDisksSpace && dataUsage.find(item => item.name === 'Used') && <>-{dataUsage.find(item => item.name === 'Used').space}GB</>}
                                        {pieChartLoaded && !isPieChartError && !isForbiddenError && !noDisksSpace && dataUsage.find(item => item.name === 'Total Storage') && <>/{dataUsage.find(item => item.name === 'Total Storage').space}GB</>}</h3>
                                    <OverlayTrigger overlay={<BTooltip>This chart displays the proportion of disk space used versus free space. If the user has an unlimited storage package, only the disk space used is shown.</BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                {!pieChartLoaded ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
                                    <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                </div>
                                    : isPieChartError ?
                                        isForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px', fontWeight: '600', fontSize: '1.5rem' }}> Please signup again to view the details </div>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{ color: 'black' }}>Please Contact Support</span></div>
                                        :
                                        <>
                                            {noDisksSpace ? (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', }} >
                                                    No Disk Space Used
                                                </div>
                                            ) : (
                                                <>
                                                <div
                                                    style={{ display: 'flex', height: '100%', alignItems: 'center' }}
                                                >
                                                    <div
                                                        className="position-relative"
                                                        style={{
                                                            height: '80px',
                                                            width: '100%',
                                                            borderRadius: '5px',
                                                        }}
                                                    >
                                                        {dataUsage.map((item, index) => (
                                                            <OverlayTrigger
                                                                key={index}
                                                                placement="top"
                                                                overlay={<BTooltip>{`${item.name}: ${item.space} GB`}</BTooltip>}
                                                            >
                                                                {item.color === '#eb5656' ? <div
                                                                    className="position-absolute"
                                                                    style={{
                                                                        height: item.name === 'Used' ? '50%' : '100%',
                                                                        width: `${item.value}%`,
                                                                        borderRadius: '5px',
                                                                        top: item.name === 'Used' ? '25%' : '0',
                                                                        backgroundColor: item.color,
                                                                        zIndex: item.name === 'Used' ? 1 : 0,
                                                                        fontWeight: 'bold',
                                                                        textAlign: 'center',
                                                                        paddingTop: '6px',
                                                                        color:'white'
                                                                    }}
                                                                >Quota exceeded by {(dataUsage.find(item => item.name === 'Used').space - dataUsage.find(item => item.name === 'Total Storage').space).toFixed(2)} GB </div> : <div
                                                                    className="position-absolute"
                                                                    style={{
                                                                        height: item.name === 'Used' ? '50%' : '100%',
                                                                        width: `${item.value}%`,
                                                                        borderRadius: '5px',
                                                                        top: item.name === 'Used' ? '25%' : '0',
                                                                        backgroundColor: item.color,
                                                                        zIndex: item.name === 'Used' ? 1 : 0
                                                                    }}
                                                                > </div> }
                                                                
                                                            </OverlayTrigger>
                                                        ))}
                                                    </div>
                                                        </div>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        marginTop: '35px',
                                                        width: '100%',
                                                    }}
                                                >
                                                    {dataUsage.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginLeft: '10px',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: '15px',
                                                                    height: '15px',
                                                                    backgroundColor: item.color,
                                                                    marginRight: '5px',
                                                                    borderRadius: '2px',
                                                                }}
                                                            ></div>
                                                            <span style={{ fontSize: '14px', color: secondaryTextColor }}>{item.name} - {(item.space).toFixed(2)} GB</span>
                                                        </div>
                                                    ))}
                                                </div>
                                                </>
                                            )}

                                            
                                        </>
                                }
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div style={cardStyle} className='card'>
                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">Top 5 Exchange Users</h3>
                                    <OverlayTrigger overlay={<BTooltip>This chart ranks the top 5 Exchange users based on the volume of data they have stored.</BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                <div style={{ width: '100%', height: '220px' }}>
                                    {top10ExchangeUsersFailed ? top10ExchangeUsersForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                        : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{ color: secondaryTextColor}}>Please Contact Support</span></div>
                                        : top10ExchangeUsers && top10ExchangeUsers.chartData ? top10ExchangeUsers.chartData.length === 0 ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}>No Record to show</div>
                                            : !hasMoreThanFourIntegers(top10ExchangeUsers.chartData[0].name) ?
                                                top10ExchangeUsers.usersData[0]['isForbiden'] ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                        :<ResponsiveContainer>
                                            <BarChart
                                                layout="vertical" // Makes it horizontal
                                                            data={top10ExchangeUsers.chartData}
                                                margin={{ top: 2, right: 0, left: 2, bottom: 20 }}
                                                barCategoryGap={0}
                                            >
                                                <XAxis
                                                    type="number"
                                                    height={40}
                                                    stroke={secondaryTextColor}
                                                    tick={{ fill: secondaryTextColor, fontSize: 14 }}
                                                    axisLine={{ stroke: secondaryTextColor }}
                                                    tickLine={{ stroke: secondaryTextColor }}
                                                >
                                                    <Label
                                                        value="GB"
                                                        position="bottom"
                                                        offset={10}
                                                        style={{ fontSize: 14, fontWeight: 'bold', fill: secondaryTextColor }}
                                                    />
                                                </XAxis>
                                                <YAxis
                                                    type="category"
                                                    dataKey="name"
                                                    width={100}
                                                    stroke={secondaryTextColor}
                                                    axisLine={{ stroke: secondaryTextColor }}
                                                    tickLine={{ stroke: secondaryTextColor }}
                                                    tick={(props) => {
                                                        const { y, payload } = props;
                                                        const label = payload.value;

                                                        // Truncate if label is longer than 10 characters
                                                        const truncatedLabel = label.length > 12 ? label.slice(0, 9) + '...' : label;

                                                        return (
                                                            <text x={"50"} y={y} textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 14, fill: secondaryTextColor }}>
                                                                {truncatedLabel}
                                                            </text>
                                                        );
                                                    }}
                                                />
                                                <Tooltip content={<BarChartTooltip />} />
                                                <Bar dataKey="Usage" barSize={25} radius={[0, 5, 5, 0]}>
                                                                {top10ExchangeUsers.chartData.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORSHBAR[index % COLORSHBAR.length]} />
                                                    ))}
                                                </Bar>
                                            </BarChart>
                                            </ResponsiveContainer> :
                                            <div style={{ color: secondaryTextColor }}>
                                                <span style={{ fontFamily: 'Roboto, sans-serif', fontSize: 'medium' }}>
                                                    By default, Microsoft reports conceal user information, such as usernames. To display this concealed information, follow these steps:
                                                </span>
                                                <ol className="mt-2">
                                                        <li>Go to the <a href="https://admin.microsoft.com/" target="_blank" rel="noopener noreferrer">Microsoft 365 admin center</a>.</li>
                                                    <li>Choose Settings in left side bar &gt; Org Settings &gt; Services.</li>
                                                    <li>Select Reports.</li>
                                                    <li>Clear <strong>Display concealed user, group, and site names in all reports</strong>, and then select <strong>Save</strong>.</li>
                                                </ol>
                                            </div>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                            <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                        </div>}

                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div style={cardStyle} className='card'>
                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">Top 5 OneDrive Users</h3>
                                    <OverlayTrigger overlay={<BTooltip>This chart ranks the top 5 OneDrive users based on the volume of data they have stored.</BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                <div style={{ width: '100%', height: '220px' }}>
                                    {top10OneDrivesUsersFailed ?
                                        top10OneDrivesUsersForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{  color: secondaryTextColor }}>Please Contact Support</span></div>
                                        : top10OneDrivesUsers && top10OneDrivesUsers.chartData ? top10OneDrivesUsers.chartData.length === 0 ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}>No Record to show</div>
                                            : !hasMoreThanFourIntegers(top10OneDrivesUsers.chartData[0].name) ?
                                                top10OneDrivesUsers.usersData[0]['isForbiden'] ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                            :<ResponsiveContainer>
                                                <BarChart
                                                    layout="vertical" // Makes it horizontal
                                                            data={top10OneDrivesUsers.chartData}
                                                    margin={{ top: 2, right: 0, left: 2, bottom: 20 }}
                                                    barCategoryGap={0}
                                                >
                                                    <XAxis
                                                        type="number"
                                                        height={40}
                                                        stroke={secondaryTextColor}
                                                        tick={{ fill: secondaryTextColor, fontSize: 14 }}
                                                        axisLine={{ stroke: secondaryTextColor }}
                                                        tickLine={{ stroke: secondaryTextColor }}
                                                    >
                                                        <Label
                                                            value="GB"
                                                            position="bottom"
                                                            offset={10}
                                                            style={{ fontSize: 14, fontWeight: 'bold', fill: secondaryTextColor }}
                                                        />
                                                    </XAxis>
                                                    <YAxis
                                                        type="category"
                                                        dataKey="name"
                                                        width={100}
                                                        stroke={secondaryTextColor}
                                                        axisLine={{ stroke: secondaryTextColor }}
                                                        tickLine={{ stroke: secondaryTextColor }}
                                                        tick={(props) => {
                                                            const { y, payload } = props;
                                                            const label = payload.value;

                                                            // Truncate if label is longer than 10 characters
                                                            const truncatedLabel = label.length > 12 ? label.slice(0, 9) + '...' : label;

                                                            return (
                                                                <text x={"50"} y={y} textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 14, fill: secondaryTextColor }}>
                                                                    {truncatedLabel}
                                                                </text>
                                                            );
                                                        }}
                                                    />
                                                    <Tooltip content={<BarChartTooltip />} />
                                                    <Bar dataKey="Usage" barSize={25} radius={[0, 5, 5, 0]}>
                                                                {top10OneDrivesUsers.chartData.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={COLORSHBAR[index % COLORSHBAR.length]} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer> :
                                            <div style={{ color: secondaryTextColor }}>
                                                <span style={{ fontFamily: 'Roboto, sans-serif', fontSize: 'medium' }}>
                                                    By default, Microsoft reports conceal user information, such as usernames. To display this concealed information, follow these steps:
                                                </span>
                                                <ol className="mt-2">
                                                        <li>Go to the <a href="https://admin.microsoft.com/" target="_blank" rel="noopener noreferrer">Microsoft 365 admin center</a>.</li>
                                                    <li>Choose Settings in left side bar &gt; Org Settings &gt; Services.</li>
                                                    <li>Select Reports.</li>
                                                    <li>Clear <strong>Display concealed user, group, and site names in all reports</strong>, and then select <strong>Save</strong>.</li>
                                                </ol>
                                            </div>
                                            :
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                            </div>}

                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div style={cardStyle} className='card'>
                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">Top 5 SharePoint Sites</h3>
                                    <OverlayTrigger overlay={<BTooltip>This chart ranks the top 5 SharePoint users based on the volume of data they have stored.</BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                <div style={{ width: '100%', height: '220px' }}>
                                    {top10ShareUsersFailed ?
                                        top10ShareUsersForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{  color: secondaryTextColor }}>Please Contact Support</span></div>
                                        : top10ShareUsers && top10ShareUsers.chartData ? top10ShareUsers.chartData.length === 0 ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}>No Record to show</div>
                                            : top10ShareUsers.usersData[0]['isForbiden'] ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                            :
                                            < ResponsiveContainer >
                                                <BarChart
                                                    layout="vertical"
                                                        data={top10ShareUsers.chartData}
                                                    margin={{ top: 2, right: 0, left: 2, bottom: 20 }}
                                                    barCategoryGap={0}
                                                >
                                                        <XAxis type="number" height={40} stroke={secondaryTextColor}
                                                            tick={{ fill: secondaryTextColor, fontSize: 14 }}
                                                            axisLine={{ stroke: secondaryTextColor }}
                                                            tickLine={{ stroke: secondaryTextColor }}>
                                                        <Label
                                                            value="GB"
                                                            position="bottom"
                                                            offset={10}
                                                            style={{ fontSize: 14, fontWeight: 'bold', fill: secondaryTextColor }}
                                                        />
                                                    </XAxis>

                                                    <YAxis
                                                        type="category"
                                                        dataKey="name"
                                                        width={100}
                                                        stroke={secondaryTextColor}
                                                        axisLine={{ stroke: secondaryTextColor }}
                                                        tickLine={{ stroke: secondaryTextColor }}
                                                        tick={(props) => {
                                                            const { y, payload } = props;
                                                            const label = payload.value;

                                                            // Truncate if label is longer than 15 characters
                                                            const truncatedLabel = label.length > 15 ? label.slice(0, 12) + '...' : label;

                                                            return (
                                                                <text x={50} y={y} textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 14, fill: secondaryTextColor }}>
                                                                    {truncatedLabel}
                                                                </text>
                                                            );
                                                        }}
                                                    />

                                                    <Tooltip content={<BarChartTooltip />} />

                                                    <Bar dataKey="Usage" barSize={25} radius={[0, 5, 5, 0]}>
                                                            {top10ShareUsers.chartData.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={COLORSHBAR[index % COLORSHBAR.length]} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                            </div>
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 mb-3">
                            <div style={cardStyle} className='card'>
                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">Top 5 Teams Sites</h3>
                                    <OverlayTrigger overlay={<BTooltip>This chart ranks the top 5 Microsoft Teams users based on the volume of data they have stored.</BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                <div style={{ width: '100%', height: '220px' }}>
                                    {top10TeamsUsersFailed ?
                                        top10TeamsUsersForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{ color: secondaryTextColor }}>Please Contact Support</span></div>
                                        : top10TeamsUsers && top10TeamsUsers.chartData ? top10TeamsUsers.chartData.length === 0 ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}>No Record to show</div>
                                            : top10TeamsUsers.usersData[0]['isForbiden'] ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                            : <ResponsiveContainer>
                                                <BarChart
                                                    layout="vertical" // Makes it horizontal
                                                        data={top10TeamsUsers.chartData}
                                                    margin={{ top: 2, right: 0, left: 2, bottom: 20 }}
                                                    barCategoryGap={0}
                                                >
                                                    <XAxis
                                                        type="number"
                                                        height={40}
                                                        stroke={secondaryTextColor}
                                                        tick={{ fill: secondaryTextColor, fontSize: 14 }}
                                                        axisLine={{ stroke: secondaryTextColor }}
                                                        tickLine={{ stroke: secondaryTextColor }}
                                                    >
                                                        <Label
                                                            value="GB"
                                                            position="bottom"
                                                            offset={10}
                                                            style={{ fontSize: 14, fontWeight: 'bold', fill: secondaryTextColor }}
                                                        />
                                                    </XAxis>
                                                    <YAxis
                                                        type="category"
                                                        dataKey="name"
                                                        width={100}
                                                        stroke={secondaryTextColor}
                                                        axisLine={{ stroke: secondaryTextColor }}
                                                        tickLine={{ stroke: secondaryTextColor }}
                                                        tick={(props) => {
                                                            const { y, payload } = props;
                                                            const label = payload.value;

                                                            // Truncate if label is longer than 10 characters
                                                            const truncatedLabel = label.length > 12 ? label.slice(0, 9) + '...' : label;

                                                            return (
                                                                <text x={"50"} y={y} textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 14, fill: secondaryTextColor }}>
                                                                    {truncatedLabel}
                                                                </text>
                                                            );
                                                        }}
                                                    />
                                                    <Tooltip content={<BarChartTooltip />} />
                                                    <Bar dataKey="Usage" barSize={25} radius={[0, 5, 5, 0]}>
                                                            {top10TeamsUsers.chartData.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={COLORSHBAR[index % COLORSHBAR.length]} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer> :
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                            </div>}
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-12 col-md-8 mb-3">
                            <div style={cardStyle} className='card'>
                                <div style={{ position: 'relative' }}>
                                    <h3 style={{ textAlign: 'center' }} className="SectionTitle">M365 Storage Overview {!horizontalBarChartFailed && !horizontalBarChartForbiddenError && horizontalBarChartLoaded &&
                                        !horizontalBarChartNoRecord && storageBar && storageBar[0] && <> - {storageBar[0].Total} GB</>}</h3>
                                    <OverlayTrigger overlay={<BTooltip>Comparison of usage across SharePoint, Teams, OneDrive, and Email.</BTooltip>}>
                                        <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />
                                    </OverlayTrigger>
                                </div>
                                <div
                                    style={{
                                        display: "flex",                // Flexbox for centering both bar and legend
                                        justifyContent: "center",       // Center horizontally
                                        alignItems: "center",           // Center vertically
                                        flexDirection: "column",        // Stack the bar chart and legend vertically
                                        height: "100%",                 // Full height of the parent container
                                        width: "100%",                  // Full width of the parent container
                                    }}
                                >
                                    {horizontalBarChartFailed ? horizontalBarChartForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}> Please signup again to view the details </div>
                                        : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{ color: secondaryTextColor }}>Please Contact Support</span></div> : horizontalBarChartLoaded ?
                                            horizontalBarChartNoRecord ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', color: secondaryTextColor }}>No Record to show</div> :
                                            <>
                                                {/* Bar chart container */}
                                                <div
                                                    style={{
                                                        display: "flex",           // Flex for the bars
                                                        justifyContent: "flex-start",  // Bar elements start from left side
                                                        height: "90px",            // Fixed height for the bars container
                                                        borderRadius: "5px",
                                                        overflow: "hidden",
                                                        width: "80%",              // You can adjust the width of the bar container here
                                                    }}
                                                >
                                                    {storageBar.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                width: `${(item.value / totalStorage) * 100}%`,  // Dynamic width of bars
                                                                backgroundColor: COLORSHBAR[index],
                                                            }}
                                                            onMouseEnter={(e) => handleMouseEnter(e, item)}  // Hover event for tooltip
                                                            onMouseLeave={handleMouseLeave}  // Hover out event
                                                        ></div>
                                                    ))}
                                                </div>

                                                {/* Custom Tooltip */}
                                                {tooltip && tooltip.visible && (
                                                        <div
                                                        className="chart-legend"
                                                        style={{
                                                            position: "absolute",
                                                            top: tooltip.y,
                                                            left: tooltip.x/2,
                                                            transform: "translateX(-50%)",  // Center the tooltip
                                                            backgroundColor: 'white',
                                                            padding: '5px 10px',
                                                            borderRadius: '5px',
                                                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                                            fontSize: '14px',
                                                            color: 'red',
                                                            fontWeight: 'bold',
                                                            zIndex: 9999,  // Ensure the tooltip appears above other elements
                                                        }}
                                                    >
                                                        {tooltip.content}
                                                    </div>
                                                )}

                                                {/* Legend */}
                                                <div
                                                    style={{
                                                        display: "flex",                // Flex for centering legend
                                                        justifyContent: "space-between",       // Center horizontally
                                                        marginTop: "35px",
                                                        width: "100%"
                                                    }}
                                                >
                                                    {storageBar.map((item, index) => (
                                                        <div key={index} style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
                                                            <div
                                                                style={{
                                                                    width: "15px",
                                                                    height: "15px",
                                                                    backgroundColor: COLORSHBAR[index],
                                                                    marginRight: "5px",
                                                                    borderRadius: "2px",
                                                                }}
                                                            ></div>
                                                            <span style={{ fontSize: "14px", color: secondaryTextColor }}>{item.name} - {item.value} GB</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
                                            <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />
                                        </div>}

                                </div>
                            </div>
                        </div>
                        {/*<div className="col-12 col-md-6 col-lg-4 mb-3">*/}
                        {/*    <div style={cardStyle}>*/}
                        {/*        <div style={{ position: 'relative' }}>*/}
                        {/*            <h2 style={{ textAlign: 'center' }}>Azure Recovery Points</h2>*/}
                        {/*            <OverlayTrigger overlay={<BTooltip>The chart provides a visual comparison of Azure recovery points.</BTooltip>}>*/}
                        {/*                <InfoCircle style={{ position: 'absolute', top: '0', right: '0' }} />*/}
                        {/*            </OverlayTrigger>*/}
                        {/*        </div>*/}
                        {/*        <div style={{ width: '100%', height: '220px' }}>*/}
                        {/*            {isAzureRecoveryPointError ? */}
                        {/*                isForbiddenError ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem' }}> Please signup again to view the details </div>*/}
                        {/*                :<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem', flexDirection: 'column', color: 'red' }}>Error <span style={{ color: 'black' }}>Please Contact Support</span></div>*/}
                        {/*                : !isAzureRecoveryPointLoaded ?*/}
                        {/*                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>*/}
                        {/*                        <img src={LoaderGif} alt="Loading..." style={{ height: "50px" }} />*/}
                        {/*                    </div>*/}
                        {/*                    : azureRecoveryPointChart && azureRecoveryPointChart.length === 0 ? */}
                        {/*                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontWeight: '600', fontSize: '1.5rem' }}>No Record to show</div>*/}
                        {/*                    :*/}
                        {/*                     <ResponsiveContainer>*/}
                        {/*                        <BarChart data={azureRecoveryPointChart}>*/}
                        {/*                            <XAxis*/}
                        {/*                                dataKey="name"*/}
                        {/*                                height={40}*/}
                        {/*                            >*/}
                        {/*                                <Label*/}
                        {/*                                    value="Points"*/}
                        {/*                                    position="bottom"*/}
                        {/*                                    offset={10}*/}
                        {/*                                    style={{ fontSize: 14, fontWeight: 'bold' }}*/}
                        {/*                                    y={210}*/}
                        {/*                                />*/}
                        {/*                            </XAxis>*/}
                        {/*                            <YAxis />*/}
                        {/*                            <Tooltip />*/}

                        {/*                            <Bar dataKey="value" radius={[5, 5, 0, 0]} onClick={({ payload }) => handleDrillDown(payload.name)}>*/}
                        {/*                                {azureRecoveryPointChart.map((entry, index) => (*/}
                        {/*                                    <Cell key={`cell-${index}`} fill={COLORSHBAR2[index % COLORSHBAR2.length]} />*/}
                        {/*                                ))}*/}
                        {/*                            </Bar>*/}
                        {/*                        </BarChart>*/}
                        {/*                    </ResponsiveContainer> */}
                        {/*            }*/}
                                    

                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="col-12 mb-4">
                            <div style={cardStyle} className='card'>
                                <h3 style={{ textAlign: 'center' }} className="SectionTitle">Microsoft Licenses</h3>
                                <div className="ag-theme-alpine">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        defaultColDef={defaultColDef}
                                        rowData={rowData}
                                        paginationPageSize={10}
                                        paginationPageSizeSelector={[10, 20, 50]}
                                        overlayLoadingTemplate={`<div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div></div>`}
                                        domLayout="autoHeight"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<div className="row">*/}

                    {/*    {Object.entries(metrics).map(([key, value]) => (*/}
                    {/*        <React.Fragment key={key}>*/}
                    {/*            <div className="col-12 col-md-6 col-lg-4 mb-3">*/}

                    {/*                <div style={cardStyle}>*/}
                    {/*                    <div style={{ display: "flex", alignItems: "center" }}>*/}
                    {/*                        <div*/}
                    {/*                            style={{*/}
                    {/*                                borderRadius: "15px",*/}
                    {/*                                background: "lightgray",*/}
                    {/*                                padding: "0.7rem",*/}
                    {/*                            }}*/}
                    {/*                        >*/}
                    {/*                            <img*/}
                    {/*                                src={value.icon} alt="icon"*/}
                    {/*                                style={{ width: "46px", borderRadius: "5px" }}*/}
                    {/*                            />*/}
                    {/*                        </div>*/}
                    {/*                        <div style={{ marginLeft: "10px" }}>*/}
                    {/*                            <h3 style={{ margin: "0" }}>{key.replace(/([A-Z])/g, " $1")}</h3>*/}
                    {/*                            <span*/}
                    {/*                                style={{*/}
                    {/*                                    fontSize: "15px",*/}
                    {/*                                    color: "gray",*/}
                    {/*                                }}*/}
                    {/*                            >*/}
                    {/*                                {key === "UsersLicenseInfo" ? "" : "Top 10 Users"}*/}
                    {/*                            </span>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}

                    {/*                    */}{/* Body Section */}
                    {/*                    <div style={{ textAlign: "left", marginTop: "15px" }}>*/}
                    {/*                        {key === "UsersLicenseInfo" ? (*/}
                    {/*                            <h6 style={{ marginTop: "13px", fontSize: "18px", fontWeight: 400 }}>*/}
                    {/*                                <span*/}
                    {/*                                    style={{*/}
                    {/*                                        fontSize: "30px",*/}
                    {/*                                        fontWeight: "700",*/}
                    {/*                                        color: "#000",*/}
                    {/*                                        marginRight: "10px",*/}
                    {/*                                    }}*/}
                    {/*                                >*/}
                    {/*                                    {licenseInfo.reduce((total, item) => total + item.ConsumedUnits, 0)}*/}
                    {/*                                </span>*/}
                    {/*                                Licence Count*/}
                    {/*                            </h6>*/}
                    {/*                        ) : (*/}
                    {/*                            <h6 style={{ marginTop: "13px", fontSize: "18px", fontWeight: 400 }}>*/}
                    {/*                                <span*/}
                    {/*                                    style={{*/}
                    {/*                                        fontSize: "30px",*/}
                    {/*                                        fontWeight: "700",*/}
                    {/*                                        color: "#000",*/}
                    {/*                                        marginRight: "10px",*/}
                    {/*                                    }}*/}
                    {/*                                >*/}
                    {/*                                    {formatBytes(value.totalUsage)}*/}
                    {/*                                </span>*/}
                    {/*                                Total Usage*/}
                    {/*                            </h6>*/}
                    {/*                        )}*/}
                    {/*                    </div>*/}

                    {/*                    <div*/}
                    {/*                        style={{*/}
                    {/*                            display: "flex",*/}
                    {/*                            justifyContent: "flex-start",*/}
                    {/*                            alignItems: "center",*/}
                    {/*                            marginTop: "10px",*/}
                    {/*                        }}*/}
                    {/*                    >*/}
                    {/*                        <span*/}
                    {/*                            style={{*/}
                    {/*                                background: "#abd2f9",*/}
                    {/*                                padding: "4px 11px",*/}
                    {/*                                fontWeight: "600",*/}
                    {/*                                borderRadius: "20px",*/}
                    {/*                                fontSize: "14px",*/}
                    {/*                                color: "#000",*/}
                    {/*                            }}*/}
                    {/*                        >*/}
                    {/*                            {value.totalUsers}: {value.totalCount}*/}
                    {/*                        </span>*/}
                    {/*                        <span*/}
                    {/*                            style={{*/}
                    {/*                                color: "#3176bc",*/}
                    {/*                                fontSize: "16px",*/}
                    {/*                                paddingLeft: "10px",*/}
                    {/*                                cursor: "pointer",*/}
                    {/*                            }}*/}
                    {/*                            onClick={() => {*/}
                    {/*                                let titleName;*/}
                    {/*                                switch (key) {*/}
                    {/*                                    case "Top10ExchangeUsers":*/}
                    {/*                                        titleName = "Top 10 Mail Users";*/}
                    {/*                                        break;*/}
                    {/*                                    case "Top10SharepointUsers":*/}
                    {/*                                        titleName = "Top 10 SharePoint Sites";*/}
                    {/*                                        break;*/}
                    {/*                                    case "Top10OnedriveUsers":*/}
                    {/*                                        titleName = "Top 10 OneDrive Sites";*/}
                    {/*                                        break;*/}
                    {/*                                    case "Top10TeamsUsers":*/}
                    {/*                                        titleName = "Top 10 Teams Users";*/}
                    {/*                                        break;*/}
                    {/*                                    case "UsersLicenseInfo":*/}
                    {/*                                        titleName = "Users License Info";*/}
                    {/*                                        break;*/}
                    {/*                                    default:*/}
                    {/*                                        titleName = "Users Info";*/}
                    {/*                                }*/}

                    {/*                                handleKpiCardClick(value.usersData, titleName);*/}
                    {/*                            }}*/}
                    {/*                        >*/}
                    {/*                            {key === "UsersLicenseInfo" ? "View: Users Info |" : "View Top 10"}*/}
                    {/*                        </span>*/}


                    {/*                        {key === "UsersLicenseInfo" && (*/}
                    {/*                            <div style={{ textAlign: "left", marginLeft: "10px" }}>*/}
                    {/*                                <span*/}
                    {/*                                    style={{*/}
                    {/*                                        color: "#3176bc",*/}
                    {/*                                        fontSize: "16px",*/}
                    {/*                                        cursor: "pointer",*/}
                    {/*                                    }}*/}
                    {/*                                    onClick={() => handleKpiCardClick(licenseInfo, "Assigned" + key)}*/}
                    {/*                                >*/}
                    {/*                                    Assigned Licence*/}
                    {/*                                </span>*/}
                    {/*                            </div>*/}
                    {/*                        )}*/}
                    {/*                    </div>*/}

                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </React.Fragment>*/}
                    {/*    ))}*/}
                    {/*</div>*/}

                    {/*<div className="mt-3">*/}

                    {/*    <div>*/}

                    {/*        <Modal*/}
                    {/*            className="modal-lg"*/}
                    {/*            isOpen={isModalOpen}*/}
                    {/*            onRequestClose={closeModal}*/}
                    {/*            style={{*/}
                    {/*                content: {*/}
                    {/*                    top: "50%",*/}
                    {/*                    left: "50%",*/}
                    {/*                    right: "50%",*/}
                    {/*                    bottom: "auto",*/}
                    {/*                    marginLeft: "-50%",*/}
                    {/*                    transform: "translate(-50%, -50%)",*/}
                    {/*                    width: "150%",*/}
                    {/*                    height: "100%",*/}
                    {/*                },*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            <div style={{ width: "100%" }}>*/}
                    {/*                <h4 style={{ textAlign: "center", marginBottom: "10px", marginTop: "10px" }}> {header}</h4>*/}
                    {/*                <button*/}
                    {/*                    onClick={closeModal}*/}
                    {/*                    style={{*/}
                    {/*                        position: "absolute",*/}
                    {/*                        top: "10px",*/}
                    {/*                        right: "10px",*/}
                    {/*                        border: "none",*/}
                    {/*                        borderRadius: "5px",*/}
                    {/*                        padding: "5px 10px",*/}
                    {/*                        cursor: "pointer",*/}
                    {/*                    }}*/}
                    {/*                >*/}
                    {/*                    X*/}
                    {/*                </button>*/}
                    {/*                <div className="col-12 col-md-6 col-lg-4 mb-3" style={{ width: "100%" }}>*/}
                    {/*                    <div className="ag-theme-alpine">*/}
                    {/*                        <AgGridReact*/}
                    {/*                            columnDefs={columnDefs}*/}
                    {/*                            defaultColDef={defaultColDef}*/}
                    {/*                            rowData={rowData}*/}
                    {/*                            pagination={!["Top 10 Mail Users", "Top 10 SharePoint Sites", "Top 10 OneDrive Sites", "Top 10 Teams Users"].includes(header)}*/}
                    {/*                            paginationPageSize={10}*/}
                    {/*                            overlayLoadingTemplate={`<div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div></div>`}*/}
                    {/*                            domLayout="autoHeight" // Optional: Adjust grid height dynamically*/}
                    {/*                        />*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}

                    {/*        </Modal>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
}

export default TenantSummary;